import { render, staticRenderFns } from "./CancelRequests.vue?vue&type=template&id=15f66255&scoped=true&"
import script from "./CancelRequests.vue?vue&type=script&lang=js&"
export * from "./CancelRequests.vue?vue&type=script&lang=js&"
import style0 from "./CancelRequests.vue?vue&type=style&index=0&id=15f66255&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f66255",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VPagination,VSimpleTable,VSkeletonLoader,VTextField})
